import { render, staticRenderFns } from "./ServicePay.vue?vue&type=template&id=3ded6af6&scoped=true"
import script from "./ServicePay.vue?vue&type=script&lang=js"
export * from "./ServicePay.vue?vue&type=script&lang=js"
import style0 from "./ServicePay.vue?vue&type=style&index=0&id=3ded6af6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded6af6",
  null
  
)

export default component.exports